<template>
  <nav class="navbar navbar-expand-lg fixed-top bg-secondary">
    <button class="navbar-toggler ms-auto me-4" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse bg-secondary" id="navbarNavAltMarkup">
      <div class="navbar-nav ms-auto">
        <router-link class="nav-link px-3 text-nowrap" to="/dashboard">
          {{ $t("navbar.dashboard") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_order')" class="nav-link px-3 text-nowrap" to="/orders">
          {{ $t("navbar.orders") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_transportation')"
          class="nav-link px-3 text-nowrap" to="/transportations">
          {{ $t("navbar.transportations") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_customer')" class="nav-link px-3 text-nowrap"
          to="/customers">
          {{ $t("navbar.customers") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_calculation')" class="nav-link px-3 text-nowrap"
          to="/calculations">
          {{ $t("navbar.calculations") }}
        </router-link>
        <!-- Vacations -->
        <div class="nav-item dropdown" v-if="$store.getters.hasPerm('view_vacationuser') || $store.getters.hasPerm('view_vacationwarehouse')" @mouseenter="open = true"
          @mouseleave="open = false">
          <span class="nav-link px-3 text-nowrap cursor-pointer dropdown-toggle">
            {{ $t("navbar.vacations") }}
          </span>
          <div class="dropdown-menu show" v-if="open" style="position: absolute;">
            <router-link class="dropdown-item" to="/warehouse-vacations" v-if="$store.getters.hasPerm('view_vacationwarehouse')">
              {{ $t("navbar.warehouseVacations") }}
            </router-link>
            <router-link class="dropdown-item" to="/user-vacations" v-if="$store.getters.hasPerm('view_vacationuser')">
              {{ $t("navbar.userVacations") }}
            </router-link>
          </div>
        </div>
        <router-link v-if="this.$store.getters.hasPerm('view_warehouse')" class="nav-link px-3 text-nowrap"
          to="/warehouses">
          {{ $t("navbar.warehouses") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_product')" class="nav-link px-3 text-nowrap"
          to="/products">
          {{ $t("navbar.products") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_stats')" class="nav-link px-3 text-nowrap" to="/overviews">
          {{ $t("navbar.overviews") }}
        </router-link>
        <router-link v-if="this.$store.getters.hasPerm('view_user')" class="nav-link px-3 text-nowrap" to="/users">
          {{ $t("navbar.users") }}
        </router-link>
        <router-link class="nav-link px-3 text-nowrap" to="/account">
          {{ $t("navbar.myProfile") }}
        </router-link>
        <div class="nav-link px-3 text-nowrap">
          <a href="https://stary.system.drevo-hosek.cz">Stará verze systému</a>
        </div>
        <router-link class="nav-link px-3 text-nowrap" to="/logout">
          {{ $t("navbar.logout") }}
        </router-link>
        <ChangeLang class="mx-4 my-2 my-md-1" />
      </div>
    </div>
  </nav>
</template>


<script>
import ChangeLang from "@/components/ChangeLang.vue"

export default {
  components: {
    ChangeLang,
  },
  data() {
    return {
      open: false
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.navbar-brand {
  font-weight: 600;
  font-size: 1.5rem;
  text-transform: uppercase;
}

.nav-link {
  font-weight: 500;
  font-size: 1.2rem;
}

#logo {
  max-height: 60px;
}

.cursor-pointer {
  cursor: pointer;
}

.dropdown-menu {
  display: block;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
}
</style>